import {
  VabsFindPaymentMethodsInput,
  VabsFindPaymentsInput,
  VabsPaymentDirection,
  requestsClient,
} from '@/shared/api';

import {
  IVabsInternalClientQueryParams,
  IVabsPaymentMethodsQueryParams,
  IVabsPaymentQueryParams,
  IVabsPaymentsQueryParams,
} from './types';

export const vabsPaymentMethodsQuery = async ({
  currencyId,
  participantType,
}: IVabsPaymentMethodsQueryParams) => {
  const input: VabsFindPaymentMethodsInput = {};

  if (currencyId) input.currencyIds = [currencyId];
  if (participantType) input.participantTypes = [participantType];
  const { vabsMyPaymentMethods } = await requestsClient.vabsMyPaymentMethods({
    input,
  });

  return vabsMyPaymentMethods;
};

export const vabsPaymentsQuery = async ({
  skip,
  search,
  limit,
  isFavorite,
}: IVabsPaymentsQueryParams) => {
  const input: VabsFindPaymentsInput = {
    pagination: { limit, skip },
    directions: [VabsPaymentDirection.Outgoing],
  };

  if (search?.trim()) input.search = search;
  if (isFavorite) input.isFavorite = isFavorite;

  const { vabsMyPayments } = await requestsClient.vabsMyPayments({ input });

  return vabsMyPayments;
};

export const vabsMyPaymentQuery = async ({ id }: IVabsPaymentQueryParams) => {
  const { vabsMyPayments } = await requestsClient.vabsMyPayment({ id });

  return vabsMyPayments;
};

export const vabsInternalClientQuery = async ({
  email,
  phoneNumber,
}: IVabsInternalClientQueryParams) => {
  const input: IVabsInternalClientQueryParams = {};

  if (email) input.email = email;
  if (phoneNumber) input.phoneNumber = phoneNumber;

  const { vabsInternalClientsForInternalPayment } =
    await requestsClient.vabsInternalClientsForInternalPayment(input);

  return vabsInternalClientsForInternalPayment;
};
